import { useScrollIntoView } from 'modules/authentication';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useIntl } from 'react-intl';
import { FieldWrapper } from 'shared/components';

interface Props {
  required?: string;
  label: string;
  placeholder?: string;
  autoFocus?: boolean;
  inputSelector?: string;
}

export const AddressOneInput: React.FC<Props> = ({
  required,
  label,
  placeholder,
  autoFocus,
  inputSelector,
}) => {
  const { formatMessage } = useIntl();
  const { handleFocus } = useScrollIntoView();

  const {
    formState: { errors },
    register,
  } = useFormContext<Settings>();

  return (
    <FieldWrapper
      name="address.addressOne"
      errors={errors}
      labelId={label}
      isRequired={!!required}
    >
      <input
        type="text"
        autoFocus={autoFocus}
        className={`input input__box input__med ${
          errors.address?.addressOne ? 'input__box__error' : ''
        }`}
        placeholder={formatMessage({
          id: placeholder,
        })}
        data-cy={inputSelector}
        onFocus={handleFocus}
        {...register('address.addressOne', {
          required:
            required &&
            formatMessage({
              id: required,
            }),
          validate: (value) => {
            if (required) {
              return (
                !!value.trim() ||
                formatMessage({
                  id: required,
                })
              );
            }
            return;
          },
        })}
      />
    </FieldWrapper>
  );
};
